import { render, staticRenderFns } from "./Waistcanvas.vue?vue&type=template&id=54f8e4be&scoped=true&"
import script from "./Waistcanvas.vue?vue&type=script&lang=js&"
export * from "./Waistcanvas.vue?vue&type=script&lang=js&"
import style0 from "./Waistcanvas.vue?vue&type=style&index=0&id=54f8e4be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8e4be",
  null
  
)

export default component.exports